
import { Component, Vue } from 'vue-property-decorator';
import Trail from './Trail.vue'
import FormIcon from './journeyicons/FormIcon.vue'
import ReturnTrail from './ReturnTrail.vue'
import GavelIcon from './journeyicons/GavelIcon.vue'
import EndCircle from './journeyicons/EndCircle.vue'

import InstructionWindowFooter from '../components/InstructionWindowFooter.vue';
import PathSidebar from '../components/PathSidebar.vue';
import NoticeOfAppearanceRspToLeaveGrantedPg from '../components/RspToLeaveGranted/NoticeOfAppearanceRspToLeaveGrantedPg.vue';
import FactumAppealBookCertificateRspToLeaveGrantedPg from '../components/RspToLeaveGranted/FactumAppealBookRspToLeaveGrantedPg.vue';
import TheHearingRspToLeaveGrantedPg from '../components/RspToLeaveGranted/TheHearingRspToLeaveGrantedPg.vue';
import CourtOrderRspToLeaveGrantedPg from '../components/RspToLeaveGranted/CourtOrderRspToLeaveGrantedPg.vue';
import AppealProcessCompleteRspToLeaveGrantedPg from '../components/RspToLeaveGranted/AppealProcessCompleteRspToLeaveGrantedPg.vue';

import {activatePage, evaluateCompletedTrails, evaluatePageState} from '@/components/utils/TrailOperations'

import { namespace } from "vuex-class";
import "@/store/modules/application";
const applicationState = namespace("Application")
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

@Component({
    components:{
        Trail,
        FormIcon,
        ReturnTrail,
        GavelIcon,
        EndCircle,
        InstructionWindowFooter,
        PathSidebar,
        NoticeOfAppearanceRspToLeaveGrantedPg,
        FactumAppealBookCertificateRspToLeaveGrantedPg,
        TheHearingRspToLeaveGrantedPg,
        CourtOrderRspToLeaveGrantedPg,
        AppealProcessCompleteRspToLeaveGrantedPg
    }
})
export default class RespondToLeaveGrantedJourneyMap extends Vue {

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    dataReady = false;
    completedTrail :boolean[] = []
    updated=0;
    numOfPages = 0;
    currentStep = 0;
    pageState : {active:boolean; status:string; ready:boolean;}[] = []
    
    showWindow = false;
    windowTitle = '';
    pathTypes = [] as string[];
    pathHeights = [] as string[];

    noticeOfAppearanceContent = false;
    factumAppealBookCertificateContent = false;
    theHearingContent = false;
    courtOrderContent = false;
    appealProcessCompleteContent = false;   
    
    mounted(){
        this.dataReady = false;

        this.currentStep = this.stPgNo.RSP_TO_LEAVE_GRANTED._StepNo;
        this.numOfPages = Object.keys(this.stPgNo.RSP_TO_LEAVE_GRANTED).length-1;

        this.getJourneyMapCurrentState();
        
        this.dataReady = true;
    }

    public completed(order, checked){        
        activatePage(order, checked, this.currentStep)
        this.getJourneyMapCurrentState();
    }

    public getJourneyMapCurrentState(){
        this.completedTrail = evaluateCompletedTrails(this.numOfPages, this.currentStep);
        this.pageState = evaluatePageState(this.numOfPages, this.currentStep);
    }

    public adjustHeights(index: number, pathHeight: string) {
        this.updated++;
        this.pathHeights[index] = pathHeight;
    }

    public displayWindow(contentType: string){
        
        this.noticeOfAppearanceContent = false;
        this.factumAppealBookCertificateContent = false;
        this.theHearingContent = false;
        this.courtOrderContent = false;
        this.appealProcessCompleteContent = false;

        if (contentType == "Notice of Appearance"){

            this.windowTitle = "Notice of Appearance";
            this.pathTypes = ["share"];
            this.pathHeights = ['28rem'];
            this.noticeOfAppearanceContent = true;

        } else if (contentType == "Factum, Appeal Book and Certificate of Readiness"){

            this.windowTitle = "The Factum, Appeal Book and Certificate of Readiness";
            this.pathTypes = ["share", "info", "info", "info", "calendar"];
            this.pathHeights = ['17rem', '0', '0', '0', '0'];
            this.factumAppealBookCertificateContent = true;

        } else if (contentType == "The Hearing"){
            
            this.windowTitle = "The Hearing";
            this.pathTypes = ["gavel"];
            this.pathHeights = ['6rem'];
            this.theHearingContent = true;

        } else if (contentType == "Court Order"){

            this.windowTitle = "Court Order";
            this.pathTypes = ["info"];
            this.pathHeights = ['6rem'];
            this.courtOrderContent = true;

        } else if (contentType == "Appeal Process Complete"){
            
            this.windowTitle = "Appeal Process Complete";
            this.pathTypes = ["info"];
            this.pathHeights = ['3rem'];
            this.appealProcessCompleteContent = true;
        } 

        this.showWindow = true;
    }

}
